// mutations.js

export default {
    updateAllDevicesList(state, devices){
        state.allDevices = devices.data
    },
   updateDevicesList(state, devices){
       state.devicesList = devices
       state.deviceTypeList = []
       let types = [] 
       state.devicesList.forEach(device=>{
           if(!types.includes(device.type)){
               types.push(device.type)
               let type = {
                   name:device.type,
                   value:device.type,
               }
               state.deviceTypeList.push(type)
           }
       })
   },
    updateCurrentDevice(state, device){
        state.currentDevice.name = device.name
        state.currentDevice.value = device.value
    },
    updateCurrentDeviceType(state, deviceType){
        state.currentDeviceType.name = deviceType.name
        state.currentDeviceType.value = deviceType.value
    },
    updateShowHeaderDeviceFilter(state, payload){
       state.showHeaderDeviceFilter = payload
    }
    
};
